module.exports = __webpack_public_path__ + "static/img/solve2.963cedca.png";